<template>
  <v-main>
    <v-container fluid>
      <v-container class="my-5">
        <v-alert border="top" border-color type="info" elevation="6">
          契約者マイページの登録受付は終了いたしました。<br />
          ご登録をご希望のお客様は契約IDを記載の上お問い合わせください。<br />
          <br />
          sms_support@nttcoms.com<br />
        </v-alert>
      </v-container>
    </v-container>
  </v-main>
</template>

<script></script>
